import React from 'react';
import { shape } from 'prop-types';
import { formatDate } from 'Helpers/date-utils';
import IconMemo from 'Assets/images/pages/web-chat/memo_icon.svg';

import style from './Memo.less';

const MemoItem = ({ item: { patientName, createdAt, ...rest } }) => (
  <a
    href={rest?.memoFileInfo?.originalPath}
    target="_blank"
    className={style.item}
    rel="noreferrer">
    <strong className={style.title}>
      <img src={IconMemo} alt="memo" />
      Memorandum
    </strong>
    <div className={style.meta}>{formatDate(createdAt, 'MMM DD,YYYY')}</div>
  </a>
);

MemoItem.propTypes = {
  item: shape({}).isRequired,
};

MemoItem.defaultProps = {};

export default MemoItem;
